//view tab
export const CLIENTCONTRACT_OPERATIONS_TAB = 'CLIENTCONTRACT_OPERATIONS_TAB'

//quick calculation data
export const QUICK_CALCULATION_DATA = 'QUICK_CALCULATION_DATA'
export const QUICK_CALCULATION_CHECKSUM = 'QUICK_CALCULATION_CHECKSUM'

//user roles
export const USER_INFO = 'USER_INFO'
export const AVAILABLE_DEPARTMENTS = 'AVAILABLE_DEPARTMENTS'

export const SESSION_TIMEOUT = 'SESSION_TIMEOUT'
